import {AgendaAppointment} from "@/core/interfaces/AgendaAppointment";

/** What the server names an appointment that has neither title nor type. */
export const DEFAULT_APPOINTMENT_TITLE = 'Rendez-vous';

/**
 * Display label of an appointment: its own title first — a program or
 * laboratory appointment carries a meaningful one that the type must not
 * hide. The type still shows through its colour everywhere, and the detail
 * modal states its name explicitly.
 */
export const appointmentLabel = (
    appointment?: Pick<AgendaAppointment, 'title' | 'appointment_type'> | null
): string => {
    return appointment?.title ?? appointment?.appointment_type?.name ?? DEFAULT_APPOINTMENT_TITLE;
};

/**
 * Name of the person the appointment is for: the beneficiary when set, else
 * the booking customer. Null without a patient — or for a patient without a
 * name, so whether one is notified must be read off `customer`, not this.
 */
export const appointmentPatient = (
    appointment?: Pick<AgendaAppointment, 'customer' | 'beneficiary'> | null
): string | null => {
    return appointment?.beneficiary?.name ?? appointment?.customer?.name ?? null;
};

/**
 * The description the pharmacist wrote, if any. The server fills the column
 * with the type name when nothing was typed, and that copy carries nothing
 * the type does not already show.
 */
export const appointmentDescription = (
    appointment?: Pick<AgendaAppointment, 'description' | 'appointment_type'> | null
): string | null => {
    const description = appointment?.description?.trim();

    return description && description !== appointment?.appointment_type?.name ? description : null;
};
